module.exports = __webpack_public_path__ + "static/img/login-image.67c9ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/login-image.png
// module id = UZsS
// module chunks = 20